/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendSupportRequest
 */
export interface SendSupportRequest {
    /**
     * 
     * @type {number}
     * @memberof SendSupportRequest
     */
    numberOfMessages?: number;
    /**
     * 
     * @type {string}
     * @memberof SendSupportRequest
     */
    description: string;
}

/**
 * Check if a given object implements the SendSupportRequest interface.
 */
export function instanceOfSendSupportRequest(value: object): value is SendSupportRequest {
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function SendSupportRequestFromJSON(json: any): SendSupportRequest {
    return SendSupportRequestFromJSONTyped(json, false);
}

export function SendSupportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendSupportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'numberOfMessages': json['numberOfMessages'] == null ? undefined : json['numberOfMessages'],
        'description': json['description'],
    };
}

export function SendSupportRequestToJSON(json: any): SendSupportRequest {
    return SendSupportRequestToJSONTyped(json, false);
}

export function SendSupportRequestToJSONTyped(value?: SendSupportRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'numberOfMessages': value['numberOfMessages'],
        'description': value['description'],
    };
}

